import BaseModel from "./_BaseModel";
import BookingServiceKendaraan from "./BookingServiceKendaraan";
import Customer from "./Customer";
import Divisi from "./Divisi";
import Status from "./Status";
import Workorder from "./Workorder";

export default class BookingService extends BaseModel {
    public readonly ucode?: string;
    public ucode_divisi?: string;
    public no_transaksi?: string;
    public tanggal_transaksi?: string;
    public ucode_customer?: string;
    public nama_customer?: string;
    public ucode_status?: string;
    public kode_status?: string;
    public nama_status?: string;
    public keterangan?: string;
    public keterangan_operator?: string;
    public divisi?: Divisi;
    public customer?: Customer;
    public status?: Status;
    public workorder_tersedia?: boolean;
    public list_booking_service_kendaraan?: BookingServiceKendaraan[] = [];
    public list_workorder?: Workorder[] = [];

    public constructor(
        ucode?: string
    ) {
        super();
        this.ucode = ucode;
    }
};
